import Avatar from '@mui/material/Avatar';
import { stringToColor } from 'lib/utils/utils';

const defaultSx = {
  width: '2rem',
  height: '2rem',
  fontSize: '1.85ch'
};

const stringAvatar = (firstName = '', lastName = '', color = null, avatarProps = {}) => {
  const firstLetter = firstName[0] ?? '';
  const lastLetter = lastName[0] ?? '';
  avatarProps = avatarProps ?? {};
  avatarProps.sx = { ...defaultSx, ...(avatarProps.sx ?? {}) };
  avatarProps.sx.bgcolor = color ?? stringToColor(`${firstName} ${lastName}`);
  avatarProps.children = `${firstLetter}${lastLetter}`;
  return avatarProps;
};

const UserAvatar = ({ firstName = '', lastName = '', color, avatarProps = {} }) => {
  return <Avatar {...stringAvatar(firstName, lastName, color, avatarProps)} />;
};

export default UserAvatar;
